/** Kitchen service day rolls at 06:00 UTC (not midnight). */
export const BUSINESS_DAY_ROLLOVER_HOUR = 6;

const pad2 = (n) => String(n).padStart(2, '0');

/**
 * Business day label as YYYY-MM-DD.
 * Before 06:00, still belongs to yesterday's service day
 * (e.g. 08/08 05:00 → 2026-08-07 so overnight tickets stay on screen).
 */
export function getBusinessDay(date = new Date()) {
  const d = new Date(date.getTime());
  if (d.getUTCHours() < BUSINESS_DAY_ROLLOVER_HOUR) {
    d.setUTCDate(d.getUTCDate() - 1);
  }
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}
